module.exports = __webpack_public_path__ + "static/media/dummy2.d6840d46.jpeg";